import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { motion } from "motion/react";
import { Svg } from "replo-utils/react/components";

const ReferralPanelBackground = (props: SvgProps) => (
  <Svg
    width="200"
    height="200"
    viewBox="6 6 200 200"
    fill="none"
    preserveAspectRatio="none"
    {...props}
  >
    <g filter="url(#filter0_d_bg)">
      <g clipPath="url(#clip0_bg)">
        <rect x="6" y="6" width="200" height="200" rx="12" fill="white" />
        <rect
          width="200"
          height="133"
          transform="translate(6 6)"
          fill="white"
        />
        <motion.g
          opacity="0.35"
          filter="url(#filter1_fn_bg)"
          animate={{
            x: [0, 18, -12, 8, 0],
            y: [0, -10, 14, -6, 0],
          }}
          transition={{
            duration: 18,
            ease: "easeInOut",
            repeat: Number.POSITIVE_INFINITY,
            repeatType: "loop",
          }}
        >
          <ellipse
            opacity="0.3"
            cx="39.2337"
            cy="67.8758"
            rx="39.2337"
            ry="67.8758"
            transform="matrix(-0.221417 -0.975179 0.901767 -0.432221 -42.626 159.409)"
            fill="#A399FD"
          />
          <ellipse
            cx="40.9784"
            cy="161.802"
            rx="34.9217"
            ry="39.3343"
            transform="rotate(-90 40.9784 161.802)"
            fill="#A661FF"
          />
          <ellipse
            cx="64.1587"
            cy="164.737"
            rx="34.3323"
            ry="61.353"
            transform="rotate(-90 64.1587 164.737)"
            fill="#788FF5"
          />
          <ellipse
            cx="-9.48992"
            cy="185.758"
            rx="23.9196"
            ry="40.5101"
            transform="rotate(-90 -9.48992 185.758)"
            fill="#FFB3C3"
          />
          <ellipse
            cx="37.4039"
            cy="78.571"
            rx="37.4039"
            ry="78.571"
            transform="matrix(-0.275959 -0.961169 0.855191 -0.518313 14.938 200.735)"
            fill="#DA6AF3"
          />
          <ellipse
            cx="149.844"
            cy="159.046"
            rx="35.4884"
            ry="66.3023"
            transform="rotate(-90 149.844 159.046)"
            fill="#FFD580"
          />
          <ellipse
            cx="27.0026"
            cy="72.8413"
            rx="27.0026"
            ry="72.8413"
            transform="matrix(-0.314965 -0.949103 0.819023 -0.57376 46.8315 209.658)"
            fill="#FFD873"
          />
          <ellipse
            cx="96.5981"
            cy="193.344"
            rx="22.656"
            ry="66.2314"
            transform="rotate(-90 96.5981 193.344)"
            fill="#B7FEAE"
          />
          <ellipse
            cx="156.194"
            cy="78.1426"
            rx="36.4934"
            ry="68.1938"
            transform="rotate(-90 156.194 78.1426)"
            fill="#B7FEAE"
          />
          <ellipse
            cx="71.8293"
            cy="92.6886"
            rx="28.6471"
            ry="60.7414"
            transform="rotate(-90 71.8293 92.6886)"
            fill="#F4408E"
            fillOpacity="0.94"
          />
          <ellipse
            cx="27.4033"
            cy="65.9635"
            rx="27.4033"
            ry="65.9635"
            transform="matrix(-0.289077 -0.957306 0.843245 -0.537529 46.8003 126.381)"
            fill="#FE816E"
            fillOpacity="0.94"
          />
        </motion.g>
        <path
          d="M206 32.7917H6M206 106.125H6M37.25 -41V179M83.25 -41V179M129.25 -41V179M175.25 -41V179"
          stroke="url(#paint0_radial_bg)"
          strokeWidth="0.5"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_bg"
        x="0"
        y="0"
        width="212"
        height="212"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="2"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_bg"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_bg"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_bg"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_fn_bg"
        x="-139.934"
        y="-67.4189"
        width="452.322"
        height="371.419"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur stdDeviation="44" result="effect1_foregroundBlur_bg" />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="3.6840047836303711 3.6840047836303711"
          stitchTiles="stitch"
          numOctaves={3}
          result="noise"
          seed={3693}
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="effect1_foregroundBlur_bg"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood floodColor="rgba(255, 255, 255, 0.2)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect2_noise_bg">
          <feMergeNode in="effect1_foregroundBlur_bg" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <radialGradient
        id="paint0_radial_bg"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(106 69) rotate(90) scale(206.516 187.742)"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <clipPath id="clip0_bg">
        <rect x="6" y="6" width="200" height="200" rx="12" fill="white" />
      </clipPath>
    </defs>
  </Svg>
);

export default ReferralPanelBackground;
